import HowBuildCreditScreen from 'features/believe/learningCenter/HowBuildCreditScreen/HowBuildCreditScreen';
import React from 'react';

export default function Page() {
  return <HowBuildCreditScreen />;
}
